<div class="placeholder-container">
  <div class="header"></div>
  <div class="item-logo-container">
    <div class="item-logo"></div>
  </div>
  <div class="item-title"></div>
  <div class="item-description"></div>
  <div class="item-search-bar"></div>
  <div class="item-section-title"></div>
  <div class="item-slide-container">
    <div class="item-container">
      <div class="item-section-image"></div>
      <div class="item-section-image-description"></div>
    </div>
    <div class="item-container">
      <div class="item-section-image"></div>
      <div class="item-section-image-description"></div>
    </div>
    <div class="item-container">
      <div class="item-section-image"></div>
      <div class="item-section-image-description"></div>
    </div>
    <div class="item-container">
      <div class="item-section-image"></div>
      <div class="item-section-image-description"></div>
    </div>
    <div class="item-container">
      <div class="item-section-image"></div>
      <div class="item-section-image-description"></div>
    </div>
  </div>
  <div class="item-section-title"></div>
  <div class="item-slide-container">
    <div class="item-container">
      <div class="item-section-image"></div>
      <div class="item-section-image-description"></div>
    </div>
    <div class="item-container">
      <div class="item-section-image"></div>
      <div class="item-section-image-description"></div>
    </div>
    <div class="item-container">
      <div class="item-section-image"></div>
      <div class="item-section-image-description"></div>
    </div>
    <div class="item-container">
      <div class="item-section-image"></div>
      <div class="item-section-image-description"></div>
    </div>
    <div class="item-container">
      <div class="item-section-image"></div>
      <div class="item-section-image-description"></div>
    </div>
  </div>
</div>
